import { Link } from "react-router-dom";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

export function ResourcesPage() {
  useDocumentTitle("Resources — Pilot Mastery Academy");

  return (
    <div className="mx-auto max-w-6xl px-4 py-16">
      <h1 className="font-display text-4xl font-semibold text-white">Resources</h1>
      <p className="mt-4 max-w-2xl text-slate-400">
        This page bridges the public site to the repository knowledge base. Deep research, SEO maps, and generated drafts
        live under <code className="text-signal-sky">knowledge-bases/</code> and <code className="text-signal-sky">outputs/</code> in the monorepo.
        Ship new articles by adding Markdown under <code className="text-signal-sky">platform/content/blog/</code> — see the{" "}
        <Link to="/blog" className="text-signal-sky hover:underline">
          Journal
        </Link>
        .
      </p>

      <div className="mt-12 grid gap-6 md:grid-cols-2">
        <div className="rounded-2xl border border-white/10 bg-deck-panel/50 p-6">
          <h2 className="font-display text-xl font-semibold text-white">Repository map</h2>
          <ul className="mt-4 space-y-2 text-sm text-slate-400">
            <li>
              <code className="text-signal-amber">prds/</code> — Canonical offer specs
            </li>
            <li>
              <code className="text-signal-amber">docs/</code> — Strategy and execution guides
            </li>
            <li>
              <code className="text-signal-amber">outputs/</code> — Generated sales drafts, SEO, calendar
            </li>
            <li>
              <code className="text-signal-amber">knowledge-bases/</code> — Market research + customer KB index
            </li>
          </ul>
        </div>
        <div className="rounded-2xl border border-white/10 bg-deck-panel/50 p-6">
          <h2 className="font-display text-xl font-semibold text-white">Programs</h2>
          <ul className="mt-4 space-y-3 text-slate-300">
            <li>
              <Link to="/offers/financial-freedom" className="text-signal-sky hover:underline">
                Aviation Financial Freedom Blueprint (#7)
              </Link>
            </li>
            <li>
              <Link to="/offers/decision-mastery" className="text-signal-sky hover:underline">
                Decision-Making Under Stress (#3)
              </Link>
            </li>
            <li>
              <Link to="/offers/career-pivot" className="text-signal-sky hover:underline">
                Pilot Career Pivot Consulting (#5)
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
